import {WixSdk} from 'js-sdk-wrapper';
import {createParam} from 'music-shared/dist/src/utils/url';
import {noop} from '../utils/functions';
import {getHostAndPath} from '../utils/url';
import {openModal, openPopup} from '../utils/wix-sdk';
import {TRACK_PAGE_DIMENSIONS} from './constants';

export function subscribeToPlayerEvents(player) {
  player.on('modal', Wix.openModal); // eslint-disable-line no-undef
  player.on('popup', Wix.openPopup); // eslint-disable-line no-undef
  player.on('closePopup', WixSdk.closeWindow);
  player.on('mobile.setHeight', () => {
    WixSdk.setHeight(player.getDimensions().maxHeight);
  });

  player.on('widget:share', showModal('share'));
  player.on('widget:track-info', showModal('track-info', true));
  player.on('feature-disabled', showFeatureDisabledPopup);

  const events = [
    'playing',
    'pause',
    'playbacktoggle',
    'timeupdate',
    'progress',
    'prev',
    'next',
    'shuffle',
    'loop'
  ];

  events.forEach(event => {
    player.on(event, (...args) => {
      WixSdk.PubSub.publish(event, args);
    });
  });
}

function showFeatureDisabledPopup() {
  const modalPath = `${getHostAndPath(true)}widget-feature-disabled.html`;
  openPopup(modalPath, '100%', '100%', noop, WixSdk.Theme.BARE);
}

function showModal(type, displayInEditor = false) {
  return function (data) {
    const viewMode = WixSdk.Utils.getViewMode();
    if (!displayInEditor && (viewMode === 'preview' || viewMode === 'editor')) {
      showFeatureDisabledPopup();
      return;
    }

    let modalPath = `${getHostAndPath(true)}modals.html#/${type}`;
    if (data) {
      modalPath += `?${createParam(data)}`;
    }
    openModal(modalPath, TRACK_PAGE_DIMENSIONS.WIDTH, TRACK_PAGE_DIMENSIONS.HEIGHT, noop, WixSdk.Theme.BARE);
  };
}



// WEBPACK FOOTER //
// ./widget-player/subscribe-to-player-events.ts